import { AvatarSize, UserAvatar } from '@/components';
import { TenantModel } from '@/modules/Tenants/domain';
import { useGetTenantProfilePicture } from '@/modules/Tenants/queries/get-tenant-profile-picture';
import { ReactElement, useEffect, useState } from 'react';

export interface CurrentTenantAvatarProps {
  size: AvatarSize;
  className?: string;
  tenant: TenantModel;
}

export const CurrentTenantAvatar = ({
  size = 'medium',
  className,
  tenant,
}: CurrentTenantAvatarProps): ReactElement => {
  const { data: image, isLoading } = useGetTenantProfilePicture(
    tenant.id,
    !!tenant.imageFileId,
  );

  const [profilePictureUrl, setProfilePictureUrl] = useState<string>();

  useEffect(() => {
    if (!image) {
      setProfilePictureUrl(undefined);
      return;
    }

    const file = new File([image], 'ProfileImage');
    const fileUrl = URL.createObjectURL(file);

    setProfilePictureUrl(fileUrl);
  }, [image]);

  return (
    <UserAvatar
      className={className}
      size={size}
      name={tenant?.name}
      imageSrc={profilePictureUrl}
      isLoading={isLoading && !!tenant.imageFileId}
    />
  );
};
